<template>
	<div>
		<div class="show-box-bg wx-login-box" v-show="this.isApp == true ? false : true">
			<div class="conten">
				<div class="titl">{{ popupMsg.title }}</div>
				<div class="text">{{ popupMsg.content }}</div>
				<div class="btn-box">
					<!-- <view class="cancel" @click='hidePopup("no")'>{{ popupMsg.cancel }}</view> -->
					<button class="confirm" @click='hidePopup("yes")'>{{ popupMsg.confirm }}</button>
				</div>
			</div>
		</div>
		<div class="show-box-bg wx-login-box" v-show="this.isApp == false ? false : true">
			<div class="conten_h5">
				<div class="titl">{{ popupMsg.title }}</div>
				<div class="text">{{ popupMsg.content }}</div>
				<div class="btn-box">
					<!-- <view class="cancel" @click='hidePopup("no")'>{{ popupMsg.cancel }}</view> -->
					<button class="confirm" @click='hidePopup("yes")'>{{ popupMsg.confirm }}</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
	export default {
		//(1)子组件中，通过props接收到数据
		props: ['popupMsg'],
		data() {
			return {
			    	
			}
		},
	computed:{
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
	  isApp(state) {
        return state.isApp;
      },
    }),
  },
		created(){
		},
		methods: {
			hidePopup:function(type) {
			    //子组件中，使用$emit调用父组件自定义事件，还可以传参
				this.$emit('handlePopup', type)
			},
		}
	}
</script>
  
<style scoped lang="less">
	.wx-login-box {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 99999;
		.conten_h5{
				width: 60%;
			background-color: #f6e072;
			z-index: 99;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			border-radius: 0.3125rem;
			overflow: hidden;
			height: auto;
			min-height: 6.25rem;
			border-radius: 0.625rem;
						.titl {
				// width: 90%;
				// height: 110rpx;
				// font-size: 40rpx;
				// padding: 0 5%;
				// line-height: 140rpx;
			}

			.text {
				font-size: 1.25rem;
				text-align: center;
				padding: 0.625rem;
				color: #5a2f04;
			}

			.btn-box {
				// background-color: rgb(239,160,222);
				// width: 100%;
				// height: 100rpx;
				// display: flex;
				// border-top: 2rpx solid #969696;

				.cancel {
					// width: 50%;
					height: 100%;
					
					font-size: 1rem;
					color: #999;
					text-align: center;
					border-right: 0.3125rem solid #969696;
				}
				.confirm {
					width: 20%;
					font-size: 1rem;
					margin: 0.5rem auto;
				padding: 0.5rem 3.125rem;
				color: aliceblue;
				background-image: linear-gradient(#8ada19 0%, #529f0c 50%, #317907 100%);
                border: solid 0.0625rem #2c6910;
				border-radius:0.3125rem;
				}
			}
			}
		.conten {
			width: 60%;
			background-color: #f6e072;
			z-index: 99;
			position: absolute;
			top: 15%;
			left: 50%;
			transform: translate(-50%, -50%);
			border-radius: 0.3125rem;
			overflow: hidden;
			height: auto;
			min-height: 6.25rem;
			border-radius: 0.625rem;
			.titl {
				// width: 90%;
				// height: 110rpx;
				// font-size: 40rpx;
				// padding: 0 5%;
				// line-height: 140rpx;
			}

			.text {
				font-size: 1.25rem;
				text-align: center;
				padding: 0.625rem;
				color: #5a2f04;
			}

			.btn-box {
				// background-color: rgb(239,160,222);
				// width: 100%;
				// height: 100rpx;
				// display: flex;
				// border-top: 2rpx solid #969696;

				.cancel {
					// width: 50%;
					height: 100%;
					
					font-size: 1rem;
					color: #999;
					text-align: center;
					border-right: 0.3125rem solid #969696;
				}
				.confirm {
					width: 20%;
					font-size: 1rem;
					margin: 0.5rem auto;
				padding: 0.5rem 3.125rem;
				color: aliceblue;
				background-image: linear-gradient(#8ada19 0%, #529f0c 50%, #317907 100%);
                border: solid 0.0625rem #2c6910;
				border-radius:0.3125rem;
				}
			}
		}

	}
</style>
